// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBOArIf8N_XYZgedYrNltreI3SUZsmtuEY',
    authDomain: 'pepe-40eb5.firebaseapp.com',
    databaseURL: 'https://pepe-40eb5.firebaseio.com',
    projectId: 'pepe-40eb5',
    storageBucket: 'pepe-40eb5.appspot.com',
    messagingSenderId: '752736043873',
    appId: '1:752736043873:web:a67551f21217f9fbf17b20'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
